export const formatYAxis = (value: any) => {
  const numValue = Number(value);
  if (numValue >= 1000000) {
    return `${(numValue / 1000000).toFixed(1)}M`;
  }
  if (numValue >= 1000) {
    return `${(numValue / 1000).toFixed(1)}k`;
  }
  return value.toString();
};

export const formatDataValue = (value: number) => {
  if (value === 0) return '';  // Não mostrar rótulo se o valor for 0
  if (value >= 1000000) {
    return `${(value / 1000000).toFixed(1)}M`;
  }
  if (value >= 1000) {
    return `${(value / 1000).toFixed(1)}k`;
  }
  return value.toString();
};